import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import LineBtn from "../../components/Button/LineBtn";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { Filters, TotalCount } from "../Users/UserInfo";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import Loader from "../../components/DefaultStyles/Loader";
import { useRecoilValue } from "recoil";
import { authType } from "../Login";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { getThousandComma } from "../../Api/ApiCommon";
import { getEllipsis } from "../../ApiTS/ApiCommonTS";

interface IAdminLog {
  act: string;
  admin: string;
  indate: string;
  reason: string;
  detail: {
    category: string;
    comment: string;
    grade: string;
    name: string;
    uid: number;
  };
}

export default function ManageLog() {
  const auth = useRecoilValue(authType);

  const [page, setPage] = useState(0);
  const [detail, setDetail] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const [dropdown, setDropdown] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");

  const [gradeList, setGradeList] = useState([
    {
      value: "",
      label: "",
    },
  ]);

  const { response, loading } = useApi({
    method: "get",
    url: auth?.adminLog
      ? `admin/log?page=${page}&size=10` +
        (searchValue ? `&${dropdown?.value}=${searchValue}` : ``)
      : undefined,
  });

  const { response: listResponse } = useApi({
    method: "get",
    url: `auth/list`,
  });

  const tableHead = ["관리자", "등급", "Act", "사유", "실행 일시", "보기"];

  const option = [{ value: "admin", label: "관리자 이름" }];

  useEffect(() => {
    if (listResponse?.status === 200) {
      const list = [];

      for (let i = 0; i < listResponse?.data?.length; i++) {
        const e = listResponse?.data[i];

        list.push({ value: e?.id, label: e?.name });
      }

      setGradeList(list);
    }
  }, [listResponse, setGradeList]);

  useEffect(() => {
    setTimeout(() => {
      setDetail(false);
    }, 100);
  }, [page]);

  return (
    <>
      <PageTitle title="운영 로그" />

      <Filters>
        <DropDown
          dropdownValue={dropdown}
          setDropDownValue={setDropdown}
          boxWidth={140}
          optionList={option}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropdown?.value === ""}
          pageResetEvent={() => setPage(0)}
        />
      </Filters>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={807}>
          <>
            {response?.data?.items?.map((d: IAdminLog, index: number) => (
              <React.Fragment key={index}>
                <TableBody>
                  <TableBodyItem>{d?.admin}</TableBodyItem>
                  <TableBodyItem>
                    {
                      gradeList?.find(
                        (val) =>
                          val?.value === d?.detail?.grade ||
                          val?.value === String(d?.detail?.grade) ||
                          String(val?.value) === d?.detail?.grade
                      )?.label
                    }
                  </TableBodyItem>
                  <TableBodyItem>{d?.act}</TableBodyItem>
                  <TableBodyItem>{getEllipsis(d?.reason, 19)}</TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.indate)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText={
                        activeIndex === index && detail ? "접기" : "보기"
                      }
                      btnClickEvent={() => {
                        setActiveIndex(index);

                        if (activeIndex === index) {
                          // 열려있을 때
                          setDetail(!detail);
                        } else {
                          // 열기
                          setDetail(true);
                        }
                      }}
                      disabled={!auth?.adminLog}
                    />
                  </TableBodyItem>
                </TableBody>

                {activeIndex === index && detail && (
                  <ManageLogTableDetailContainer>
                    <ManageLogTableDetailContent colSpan={6}>
                      {JSON.stringify(d?.detail)}
                    </ManageLogTableDetailContent>
                  </ManageLogTableDetailContainer>
                )}
              </React.Fragment>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={response?.data?.items?.length < 1 || !response}
        tableHead={tableHead}
        pushedData={(d: any) => {
          return [
            d.admin,
            gradeList?.find(
              (val) =>
                val?.value === d?.detail?.grade ||
                val?.value === String(d?.detail?.grade) ||
                String(val?.value) === d?.detail?.grade
            )?.label,
            d?.act,
            getEllipsis(d?.reason, 19),
            dayjs(d?.indate)?.format("YYYY-MM-DD HH:mm"),
          ];
        }}
        dataUrl={
          `admin/log?page=0&size=1000` +
          (searchValue ? `&${dropdown?.value}=${searchValue}` : ``)
        }
        title="운영 로그"
      />

      {loading && <Loader />}
    </>
  );
}

export const ManageLogTableDetailContainer = styled.tr`
  width: 100%;
  background-color: #f5f5f5;
`;

export const ManageLogTableDetailContent = styled.th`
  padding: 20px;
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
`;
